
$(function($) {
  var ProductObj = {
    'sio-facelift':
      'This pack of 4 most popular patches will help you achieve radiantly smooth and hydrated skin in hours - from brow, eye, mouth to neck.',

    'sio-brow-lift':
      '	Noticing deeper lines starting to form? Fight brow lines and creases with our silicone technology that compresses wrinkles and hydrates skin.',

    'sio-necklift':
      "Smoother skin is one night's sleep away with SiO's NeckLift that will tighten, tone and hydrate the delicate skin on your neck - where no injectibles go.",

    'eye-smile-lift':
      'Smiling is amazing, and it leaves marks. Eliminate crows feet and marionette lines in one fell swoop - and dont forget to smile!',

    'sio-super-eyelift':
      "Get rid of creases under the eye, on the browbone and crow's feet after one use with SiO's deep hydration wrinkle compressing technology.",

    'sio-super-liplift-2pk':
      "A super easy fix for straw users, lip pursers and those with smoker lines - SiO's wrinkle compressing technology will smooth them all in one swoop with.",

    'wrinkle-rescue-patch-pack':
      'This is a best-of pack - 5 different patches. SiO to the rescue to smooth skin from face, neck to chest.',

    'decollete-cleansing-discs':
      "Restore the décolleté to its youthful prime. SiO works where injectables don't dare to go.",

    'sio-handlift ':
      'Your hands do so much for you - they deserve a little papering. SiO HandLift will give them deep hydration and make wrinkles disappear.',

    'sio-elbow-knee-rescue-lift':
      'Because joints get wrinkles too - enjoy smoother skin in just a few hours.',

    'sio-for-him-browlift':
      'Everyone gets brow lines, so SiO is here to help.',

    'sio-for-him-eye-smile-lift':
      'A no-needle solution to flatten and prevent creases around your eyes and mouth.',

    'sio-for-him-facelift':
      'Diminish signs of aging on the brow and around the eyes and mouth.',
    'gift-card':
      'Give the gift of choice with a SIO Beauty gift card.',
    'superlift':
      'It’s not that kind of facelift, but the results will make them wonder. Made of medical grade silicone, SiO patches gently compress your skin to stay flat and smooth.',
    'cryosystem':
      'The SiO Cryo System comes with the SiO Cryodrop and SiO Energy Serum. The Cryodrop is skin-toning tool that uses cold therapy and massage to visibly reduce redness, pore size and puffiness. The Energy Serum contains active ingredients that refresh the skin and fight signs of aging.',
    'cryodrop':
      'Breakthrough skin-toning tool that uses the power of cold therapy and massage to visibly reduce redness, pore size and puffiness.',
    'energy-serum':
      'This serum features innovative cooling technology to refresh the skin and fight signs of aging.',
  };
  //initial method invoked
  function initQuickView(result) {
    
    var url = window.location.href;
    // check for collection pages with no product page and for less than 600 width
    
      $('body').addClass('mobileQuickView');
      setTimeout(function() {
        $('.quick-view-overlay').remove();
      }, 2000);
      var quickViewWrapper = $('body.mobileQuickView .quick-view');
      var productTitle = quickViewWrapper.find(
        '#product-wrap .title-container .subtitle'
      );
      var productGallery = quickViewWrapper.find('#product-wrap .product-gallery');
      var ratings = quickViewWrapper.find(
        '.collectionYot.yotpo.bottomLine'
      );
      var fullDetails = quickViewWrapper.find(
        '#product-wrap a.full-details'
      );
      console.log($(ratings));
      // ratings at top
      //$(ratings).insertBefore(productGallery);
      //adding product name after ratings
      //$(productTitle).insertBefore(productGallery);
      //var productTeasure;
      //$('.prod-teasure').remove();
      // product teasure add at top
      /*if (result) {
        productTeasure = document.createElement('p');
        productTeasure.setAttribute('class', 'prod-teasure');
        productTeasure.innerHTML = ProductObj[result];
        $(productTeasure).insertAfter(productGallery);
        
      }*/

      // full detail cta
      /*fullDetails.html('<i>See full page</i>');
      if(window.screen.width <= 768){
        $(fullDetails).insertBefore(productGallery);
      }else{
        $(fullDetails).insertAfter(productTeasure);
      }*/
      
      if(quickViewWrapper.find('#rc_container').size() <= 0){
        quickViewWrapper.find('.price').show()
      }

      quickViewWrapper.find('#product-wrap .description meta').remove();
  }


  	if(!isMobile.any) {
      $('body').addClass('isNotMobile'); 
    }

    $(document).on("click", ".quantity-box .minus", function() {
        var wrapper = $(this).parent();
        console.log('clicking minus');
      try {
          wrapper.find('input[type=number]').get(0).stepDown();
          wrapper.find('input[type=number]').change();
        } catch(e) {
          var value = (parseInt(wrapper.find('input[type=number]').val())-1);
          wrapper.find('input[type=number]').val((value>=0 ? value : 0));
          wrapper.find('input[type=number]').change();
        }
    });
    $(document).on("click", ".quantity-box .plus", function() {
        var wrapper = $(this).parent();
      try {
          wrapper.find('input[type=number]').get(0).stepUp();
          wrapper.find('input[type=number]').change();
        } catch(e) {
          var value = (parseInt(wrapper.find('input[type=number]').val())+1);
          wrapper.find('input[type=number]').val(value);
          wrapper.find('input[type=number]').change();
        }
    });

    /********* QUICK VIEW *********/
    
  	var gaTrackingCategory = "Homepage";
  	$(document).on('click', '.product-item .quick-view-btn', function(){
      var url = $(this).data('url');
      var self = $(this);
      $('#loading-overlay').show();
	  var $this = $(this);
      $.ajax({
        url: url,
        cache: false
      }).success(function(data){
        $('#loading-overlay').hide();
        
        modal = new tingle.modal({
          closeMethods: ['overlay', 'escape'],
          closeLabel: "Close",
          cssClass: ['quick-view']
        });
        modal.setContent(data);
        modal.open();
        
        var arrProd = Object.keys(ProductObj);
        result = false;
        
        arrProd.forEach(function(item) {
          console.table([self.data('url').indexOf(item),self.data('url'),item])
          if (self.data('url').indexOf(item) != -1) {
            result = item;
            console.log(item);
          }
        });

        initQuickView(result);

        setTimeout(function(){
          $('.quick-view-overlay').fadeOut();
        },1000);        
        

        //GA custom tracking
        var product =  $this.data('url').replace("/products/", "").replace("?view=quick-view", "");
        var category = "Homepage";
        var section = $this.closest(".container").find("h2>a").text();
        if(section.length > 0){
          category = section + " carousel";
        }
        
        
        var url = window.location.href;
        if(url.indexOf("/products/") > 0){
          category = "Related Products PDP";
        }

        if(url.indexOf("/cart") > 0){
          category = "Related Products cart";
        }

        if(url.indexOf("/") > 0){
          category = "Homepage";
          product = "Carousel Quickview";
        }

        if(url.indexOf("/collections/") > 0){
          category = "Quickview";
          product = $this.data('url').replace("/products/", "").replace("?view=quick-view", "");
        }

        gaTrackingCategory = category;
        gtag('event', product,{ event_category: category, event_label: "quickview initiated" });
        
        
      });

      return false;
    });

    /********* PRODUCT CARD QUICK VIEW *********/

    $(document).on('click', '.product-card .quick-view-trigger', function(){
      var url = $(this).data('url');
      var self = $(this);
      $('#loading-overlay').show();
	    var $this = $(this);
      $.ajax({
        url: url,
        cache: false
      }).success(function(data){
        $('#loading-overlay').hide();
        
        modal = new tingle.modal({
          closeMethods: ['overlay', 'escape'],
          closeLabel: "Close",
          cssClass: ['quick-view']
        });
        modal.setContent(data);
        modal.open();
        
        var arrProd = Object.keys(ProductObj);
        result = false;
        
        arrProd.forEach(function(item) {
          console.table([self.data('url').indexOf(item),self.data('url'),item])
          if (self.data('url').indexOf(item) != -1) {
            result = item;
            console.log(item);
          }
        });

        initQuickView(result);

        setTimeout(function(){
          $('.quick-view-overlay').fadeOut();
        },1000);        
        

        //GA custom tracking
        var product =  $this.data('url').replace("/products/", "").replace("?view=quick-view", "");
        var category = "Homepage";
        var section = $this.closest(".container").find("h2>a").text();
        if(section.length > 0){
          category = section + " carousel";
        }
        
        var url = window.location.href;

        if(url.indexOf("/collections/") > 0){
          category = "Quickview";
          product = $this.data('url').replace("/products/", "").replace("?view=quick-view", "");
        }

        gaTrackingCategory = category;
        gtag('event', product,{ event_category: category, event_label: "quickview initiated" });
        
      });

      return false;
    });
    
    //BEAM START
    var render = true;
    $('a, input, div, button, span').click(function() {
      const widget = document.createElement("beam-select-nonprofit");
      const parent = document.getElementsByClassName('rebuy-cart__flyout-apps').item(0);
      
      widget.chainId = "118";
      widget.apiKey = "WfmKqfg6gejo.144f3024-c5b6-49e7-8071-8b6a6fb8ab2b";
      widget.storeId = 264;
      widget.baseUrl = "https://production-central-backend-ne.beamimpact.com";
      widget.style= "padding: 0px 0px 10px; margin: -5px 0px 0px 0px;";
      widget.id = "beam-widget";
      if(render){
      $( parent ).append(widget);
        render = false;
      }
    });
    //BEAM STOP

  	if($('#side-cart').length > 0) {      
    	initSideCart();
      document.addEventListener('rebuy.ready', function(){
        if (Rebuy.SmartCart.status == "ready") {
          $('.header .cart-wrap > a').click(function(e){
           Rebuy.SmartCart.show();
          })
        }
      });
  	}
  
  	$(document).on("click", ".add-to-cart-mens", function(){
  		var pid = $(this).attr("data-prodid");
        console.log(pid);
        $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              async: false,
              data: {
                quantity: 1,
                id: pid
              },
              dataType: 'json',
              success: function(){
                updateCartDesc()
                clickToCall()
              },
              cache: false
          });
  
    });
 	$(document).on("click", ".add-to-cart-fp", function(event){
      event.preventDefault();
      var pid = $(this).attr("data-prodid");
      var element = $(this);
      $('#loading-overlay').show();
      console.log(pid);
      $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            async: false,
            data: {
              quantity: 1,
              id: pid
            },
            dataType: 'json',
            success: function(){
              gtag('event', 'Carousel ATC',{ event_category: 'Homepage', event_label: "added to cart" });
              updateCartDesc()
              clickToCall()
            },
            cache: false
        });
    });
  
  	 
    if(window.location.href === "https://www.siobeauty.com/collections/all"){
      document.cookie = "showCTC=Yes; path=/;";
      clickToCall();
    }
  

  	
  		$('body').delegate('.add-to-cart-form', 'submit', function(){
            if(validateAddCart($(this))) {
              //if (giftsSelected($(this))) {
                //fbPixelAddToCart();

                
                  addToCart($(this));
                
                //custom GA tracking
                /*var url = window.location.href;
                var category = gaTrackingCategory;

                var product = $(this).find("h1.title").text();
                ga('littledata.send', 'event', category, product, "add to cart");*/
              //}
            }
            return false;
        });
        $('body').delegate('.add-to-cart', 'click', function(e){
          e.preventDefault();
          $('#loading-overlay').show();
          console.log('adding from plp')
          
            addToCartPLP($(this));
          
          

          //custom GA tracking
          /*var url = window.location.href;
          var category = gaTrackingCategory;

          var product = $(this).find("h1.title").text();
          ga('littledata.send', 'event', category, product, "add to cart");*/

          return false;
        });
  		$('body').delegate('.add-to-cart-form input[type="submit"]', 'click', function(){
            $('.add-to-cart-form').submit();
            return false;
        });
  	

  	$(window).scroll(function(){
      if($(this).scrollTop()<=200) {
        $('.scrollup').fadeOut();
      } else {
        $('.scrollup').fadeIn();
      }

      
    });
  
  	setupDropdownMenus();  

    $('iframe[src*=youtube], iframe[src*=vimeo]').mediaWrapper({
      intrinsic: true
    });

    //recharge account nav

    $('#rc_navigation a').each(function(){
      let objHref = $(this).attr('href').replace('http:','');
      let windowLocation = window.location.href.replace('https:','');
      if(objHref == windowLocation){
        $(this).parent().addClass('active');

      }
    });

    $('#ReCharge .discount-form .action__applyDiscount').text('Apply');

});

/**
 * Support for dropdown menus
 */
function setupDropdownMenus(){
	$('.main-menu .has-dropdown').hoverIntent( navRollOver, navRollOut );
	$('.main-menu .has-dropdown .submenu').hoverIntent( submenuIdle, navRollOut );
  
	function navRollOver(e){
		$(this).addClass('active').find('.submenu:first').slideDown();
    $(this).find(">a").attr('aria-expanded', 'true');
      	var txt = $(this).find(">a").text().trim();
    	gtag('event', txt,{ event_category: "Top Nav", });
	}
	function navRollOut(e){
		$(this).removeClass('active').find('.submenu:first').slideUp();
    $(this).find(">a").attr('aria-expanded', 'false');
	}
  function submenuIdle(e){
    $(this).show();
  }
}

function selectGifts(refresh) {
  //var freeItemsIds = [13599221547113];
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    async: false,
    dataType: 'json',
    success: function(data){
      var items = data.items;
      var currentVarId;
      var hasFreeProduct = false;
      var hasSubscription = false;
      var firstSubscription;
      var isMen = false;

      items.forEach(function(e,i,a){
        currentVarId = e.variant_id;
        //if(freeItemsIds.includes(currentVarId)) {
          if(e.properties && e.properties["free-gift"]){
            hasFreeProduct = true;
          }
          if(e.properties && e.properties["subscription_id"]){
            hasSubscription = true;
            if (!firstSubscription)
              firstSubscription = e;
          }
        //}
      });

      if(!hasFreeProduct && hasSubscription) {
        var product_title = firstSubscription.product_title.toLowerCase();
        if (product_title.indexOf("for him")>=0
          || product_title.indexOf("men's")>=0
          || product_title.indexOf("men’s")>=0) {
          isMen = true;
        }
        $.ajax({
          type: 'GET',
          url: '/collections/free-gifts?view=free_gifts',
          cache: false,
          error: addToCartFail,
          success: function(result) {
            $('#loading-overlay').hide();
            //$('.mini-cart').remove();
          	//$('.top-utils li.cart-wrap:visible').append(data);
            //Simplistic.openModalFreeGift(result);
            var hiddenContainer = $('<div class="visuallyhidden">')
            hiddenContainer.append(result).appendTo('body');
            
            /*
            $('#free-gifts .btn-no').on("click", function() { 
              if(refresh){
                location.reload();
              }else{
                if(modal) modal.close();
              }
            });*/
            
            $('#free-gifts .btn-add').on("click", function() {
              $('#free-gifts .msg-error').html('');
              var giftId = $("#free-gifts").find('input[name=product-gift]:checked').val();
              if(!giftId){
                $('#free-gifts .msg-error').html('You have not selected any item.');
              }else{
                if(refresh){
                  addFreeItemNew(function(){location.reload();}, giftId);
                }else{
                  addFreeItemNew(function(){hiddenContainer.remove();updateCartDesc()}, giftId);
                }
              }
            });

            if (isMen) {
              $('#free-gifts .product-item input[name=product-gift]').last().prop('checked', true);
            } else {
              $('#free-gifts .product-item input[name=product-gift]').first().prop('checked', true);
            }
            $('#free-gifts .btn-add').click();
            if(refresh){
              location.reload();
            }else{
              updateCartDesc();
            }
          },
        });
      }else{
        if(refresh){
          location.reload();
        }else{
          updateCartDesc();
        }
      }

    },
    cache: false
  });
  
}

function validateAddCart(form) {
  if(form.find('input[name=id]').val()=='') {
        var allOptionsSelected;
      	if(form.find('.single-option-selector').length > 0) {
            allOptionsSelected = true;
            form.find('.single-option-selector').each(function(){
                if($(this).val()=="") {
                    allOptionsSelected = false;
                    return false;
                }
            });
        } else {
          	allOptionsSelected = false;
        }
      	
      	if(allOptionsSelected) {
          	var errorMsg = form.find('.validation-msg').text();
          	if(errorMsg) {
          		alert(errorMsg);
            } else {
            	alert("The selected variant is sold out.");
            }
        } else {
        	var labels = [];
            form.find('.options label').each(function(key, obj){
                labels.push($(obj).text().replace(':', '').trim());
            });
            alert("You must select a "+labels.join('/')+".");
        }
      	return false;
    }
  	return true;
}

/*function initMiniCart() {

  if($(window).width() < 901){

	$('.header .cart-wrap > a').click(function(e){
      e.stopPropagation();
      
      if($('.mini-cart').is(':visible')){
        hideMiniCart();
      }else{
        showMiniCart(true);
      }
      
      return false;
    });

    $(document).click(function(event){

      if(!$(event.target).closest('.mini-cart').length && $('.mini-cart').is(':visible')) {
        hideMiniCart();
      }
    });
  }
}*/

function initSideCart() {
	$('.header .cart-wrap > a').click(function(e){
      e.stopPropagation();
      e.preventDefault();
      showSideCart(true);
      return false;
    });

    $(document).click(function(event){
      if(!$(event.target).closest('#side-cart').length && $(event.target).attr('id')!="loading-overlay" && $('#side-cart').hasClass('open')) {
        hideSideCart();
      }
    });
}



function processProductLimit(obj, productId, prodAddedQty, callback){
  
  var filtered = null;
  var totalQty = 0;
  var maxQty = 5;

  
  $.getJSON('/cart.js').done(function(data){
    var cart = data.items;
    var filteredQty = 0;
    
      if(cart){
        filtered = cart.filter(function(item){
          return item.id === productId;
        })
        filteredQty = (filtered.length > 0) ? filtered[0].quantity : filteredQty;
      }
      
      
        totalQty = filteredQty + prodAddedQty;
        
          
        if(totalQty > maxQty){
          $('#loading-overlay').hide();
          Simplistic.openModal('<div class="error-itemincart">This promo has a quantity limit of 5 per product.</div>', 'message');
          //alert('This promo has a quantity limit of 5 per product.');
          return false;
        }
      
        callback(obj);
      
    
  });
}

/**
 * Ajax add-to-cart
 */
function addToCart(form){
	$('#loading-overlay').show();
    if(modal) modal.close();
    
	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		data: form.serialize(),
		dataType: 'json',
		error: addToCartFail,
    success: function(){
          let purchaseType = form.find('[name="purchase_type"]:checked').val();
          
          if(!form.hasClass('quickview-form')){
            _learnq.push(['track', 'Added To Cart', item]) // Add To Cart Klaviyo
          }
          //console.log("Klaviyo Add To Cart Started / Item: " + item.Name + "/" + item.ProductID);

          //$(".free-shipping-message").remove();
          if(purchaseType == 'autodeliver'){
            console.log('is autodeliver, adding free item...');
            
            /*** Uncomment the line below to turn the free gift on ***/
            //addFreeItem(updateCartDesc);
            //updateCartDescAndSelectGifts(form);
            
            /*** Remove the line below when the free gift is on ***/
            addToCartSuccess();

          }else{
            addToCartSuccess();
          }
          
          var price = "";
          if($(".price").length){
            price = $(".product-info .price:visible .deal").text().trim();
            price = price.replace("$", "");
          }
          
          //pinterest tracking
          pintrk('track', 'addtocart', {
          value: price,
          order_quantity: 1,
          currency: 'USD'
          });

          //Conversion tag SIO-874
          gtag('event', 'conversion', { 'send_to': 'AW-867505081/G5X0CJfUjswCELmn1J0D', 'event_callback': "" });
          
          if(form.hasClass('quickview-form')){
            gtag('event', 'quickview add to cart',{ event_category: 'Quickview' });
          }
          gtag('event', 'add to cart',{ event_category: 'PDP (new)' });

          //click to call, sio-131
           clickToCall()
          //end click to call, sio-131
        },
		cache: false
	});
}

function addToCartPLP(obj){

  let prod = {
    id: obj.data('prodid'),
    quantity: 1
  }

  $.ajax({
		type: 'POST',
		url: '/cart/add.js',
		data: prod,
		dataType: 'json',
		error: addToCartFail,
		success: function(){
      addToCartSuccess();   
    },
		cache: false
	});

  if(obj.hasClass('is-related')){
    gtag('event', 'added to cart',{ event_category: 'Related product',event_label: "added to cart" });
  }
}

function reChargeProcessCart() {
  //redirect to Recharge Checkout
	function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
	do {
    token=get_cookie('cart');
	}
	while(token == undefined);

	var myshopify_domain = Shopify.shop;
	try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
	var customer_param = (window.customerId ? '&customer_id='+window.customerId : '') + (window.customerEmail ? '&customer_email='+window.customerEmail : '')
	var discount_param = '&discount='+encodeURIComponent('');
	checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker+customer_param+discount_param;
	location.href = checkout_url;
}

function addToCartByHandle(productHandle, subscribeIfPossible) {
  $('#loading-overlay').show();
  $.get('/products/'+productHandle+'?view=json').done(function(response) {
    var json = JSON.parse(response);
    var variant = null;
    for (var i=0; i<json.variants.length; i++) {
      if (json.variants[i].available) {
        variant = json.variants[i];
        break;
      }
    }
    var data = {
      "id": variant.id,
      "quantity": 1,
    }
    if (subscribeIfPossible) {
      if (json.subscriptions.original_to_hidden_variant_map && json.subscriptions.original_to_hidden_variant_map[variant.id]) {
        data.id = json.subscriptions.original_to_hidden_variant_map[variant.id].discount_variant_id;
      }
      data.properties = {
        "subscription_id": json.subscriptions.subscription_id,
        "shipping_interval_unit_type": json.subscriptions.shipping_interval_unit_type,
        "shipping_interval_frequency": json.subscriptions.shipping_interval_frequency.split(',')[0].trim()
      }
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(){
        if (json.subscriptions.subscription_id)
          reChargeProcessCart();
        else 
          location = '/checkout';
      },
      error: function() {
        location = '/products/'+productHandle;
      },
      cache: false
    });

  }).fail(function() {
    location = '/products/'+productHandle;
  });

}

function clickToCall(){
//click to call, sio-131
//also update click-to-call.liquid - it is used on the checkout page, where this file is not referenced.
          return false; //click to call is currently not active. remove this line to turn it back on!d
           var dt = new Date();     
           dt.setTime(dt.getTime()+dt.getTimezoneOffset()*60*1000);
           var offset = -300; //Timezone offset for EST in minutes.
           var easternDate = new Date(dt.getTime() + offset*60*1000);

           var currentHour = easternDate.getHours();

           var currentDay = easternDate.getDay();
          
           var currentMonth = easternDate.getMonth();
           var currentDate = easternDate.getDate();

           var holiday = false;
           if(currentMonth == 11 && currentDate == 25){
              holiday = true; 
           }

           if(currentMonth == 11 && currentDate == 24){
              holiday = true; 
           }

           if(currentMonth == 0 && currentDate == 1){
              holiday = true; 
           }
           // console.log(currentDay)
           //must be be between 9am and 8pm M-F
           if(currentHour > 8 && currentHour < 20 && currentDay !== 0 && currentDay !== 6 && holiday == false){
              $("body").addClass("clickToCall");
              $(".clickToCall-promobar").remove();
                var promobar = "<div id='clickToCall-promobar' class='clickToCall-promobar'><div class='left-ctc-wrap'><p class='get-sio-p'>EASY ORDER BY PHONE</p> </div><a href='tel:8777509231' class='ctc-number' onclick='ctcTrack()' ><button type='button' class='ctc-button'>Click To Call</button></a></div>";
              $("header#header").prepend(promobar);
        }
  
        
          //end click to call, sio-131

}


function addFreeItem(callback){
  //var freeItemVariantId = 21245983391849;
  //var freeItemVariantId = 21397734424681;
  var freeItemVariantId = 21633229717609;
  
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    async: false,
    dataType: 'json',
    success: function(data){
       var items = data.items;

       var currentVarId;
       var quantity;
       var hasFreeProduct = false;
       items.forEach(function(e,i,a){
         currentVarId = e.variant_id;

         if(currentVarId === freeItemVariantId) {
           hasFreeProduct = true;
           quantity = e.quantity;
         }
       });
      
        if(!hasFreeProduct) {
          $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              async: false,
              data: {
                quantity: 1,
                id: freeItemVariantId
              },
              dataType: 'json',
              error: addToCartFail,
              success: function(){
                callback();
              },
              cache: false
          });
          
        } else {

          if(quantity >= 1) {
             $.ajax({
                  type: 'POST',
                  url: '/cart/change.js',
               	  async: false,
                  data: {
                    quantity: 1,
                    id: freeItemVariantId
                  },
                  dataType: 'json',
                  error: addToCartFail,
                  success: function(){
                    callback();
                  },
                  cache: false
              });
          }
        }
    },
    cache: false
  });
  
  
}

function addFreeItemNew(callback, freeItemVariantId, refresh){
  //var freeItemVariantId = 21245983391849;
  //var freeItemVariantId = 21397734424681;
  //var freeItemsIds = [13599221547113];
  
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    async: false,
    dataType: 'json',
    success: function(data){
      var items = data.items;

      var currentVarId;
      var quantity;
      var hasFreeProduct = false;
      var hasSubscription = false;
      
      items.forEach(function(e,i,a){
        currentVarId = e.variant_id;
        //if(freeItemsIds.includes(currentVarId)) {
          if(e.properties && e.properties["free-gift"]){
            hasFreeProduct = true;
          }
          if(e.properties && e.properties["subscription_id"]){
            hasSubscription = true;
          }
        //}
      });

      if(!hasFreeProduct && hasSubscription) {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          async: false,
          data: {
            quantity: 1,
            id: freeItemVariantId,
            properties: {
              "free-gift": true
            }
          },
          dataType: 'json',
          error: addToCartFail,
          success: function(){
            callback();
          },
          cache: false
        });

      }
    },
    cache: false
  });
  
  
}

function addToCartSuccess(jqXHR, textStatus, errorThrown){
	updateCartDesc(true);
  	// SIO-900 Add To Cart Event
  	gtag('event', "add to cart",{ event_category: "PDP" });
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  	var response = $.parseJSON(jqXHR.responseText);
  	$('#loading-overlay').hide();
  	Simplistic.openModal('<div class="error-itemincart">'+response.description+'</div>', 'message');
}


function updateCartJson() {
  return $.getJSON('/cart.json').done(function(data) {
    window.updatedCartJson = data;
  });
}
var setFreeProductWithScriptTimeoutID = 0;
var updatingCart = false;
var mustUpdateAgain = false;
function setFreeProductWithScript(type, collection) {
  //IMPORTANT: must prevent concurrent execution of this script

  mustUpdateAgain = false;
  clearInterval(setFreeProductWithScriptTimeoutID);

  //execute code with delay trying to use the last cart info available
  setFreeProductWithScriptTimeoutID = setTimeout(function() {
    if (updatingCart) {
      mustUpdateAgain = true;
      return;
    }
    
    updatingCart = true;

    if (type == "min_amount") {

      if (window.updatedCartJson) {
        //settings
        var minAmount = 65*100; //4000 = $40 usd
        var freeProductId = 6878969856105;
        var freeProductVariantId = 40106849075305;
  
        var cart = window.updatedCartJson;
        var freeProductAutoAddedInCart = null;
        var total_price = cart.total_price;
        updatedCartJson.items.forEach(function(item){
          if (item.product_id==freeProductId) {
            
            if (item.properties['auto_added']) {
              freeProductAutoAddedInCart = item.key;
              total_price -= item.line_price;
              return false;
            }
          }
        })
        
        successHandler = function(){
          if (location.pathname.startsWith('/cart'))
            location.reload();
          else
            updateCartDesc(true);
        };
  
        alwaysHandler = function() {
          updateCartJson().done(function() {
            updatingCart = false;
            if (mustUpdateAgain) {
              setFreeProductWithScript();
            }
          });
        };
  
        
          if (freeProductAutoAddedInCart) {
            var updates = {};
            updates[freeProductAutoAddedInCart] = 0;
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: {
                updates: updates
              },
              dataType: 'json',
              success: successHandler,
              cache: false
            }).always(alwaysHandler);
          } else {
            updatingCart = false;
          }
  
        
  
        //IMPORTANT: remember to update the 'updatingCart' variable on all possible sync or async flows
  
      } else {
        updatingCart = false;
      }

    } else if (type == "collection") {

      var freeGiftCollection = [];

      if (window.updatedCartJson) {

        //settings
        if (collection) {freeGiftCollection = collection;}
        var freeProductId = 6878969856105;
        var freeProductVariantId = 40106849075305;
        var cart = window.updatedCartJson;
        var freeProductAutoAddedInCart = null;
        var collectionProductInCart = false;

        console.log(freeGiftCollection);

        updatedCartJson.items.forEach(function(item){
          if (item.product_id==freeProductId) {
            if (item.properties['auto_added']) {
              freeProductAutoAddedInCart = item.key;
              total_price -= item.line_price;
              return false;
            }
          }
          if (freeGiftCollection.includes(item.product_id)) {
            collectionProductInCart = true;
          }
        });
        
        successHandler = function(){
          if (location.pathname.startsWith('/cart'))
            location.reload();
          else
            updateCartDesc(true);
        };
  
        alwaysHandler = function() {
          updateCartJson().done(function() {
            updatingCart = false;
            if (mustUpdateAgain) {
              setFreeProductWithScript();
            }
          });
        };
  
        
          if (freeProductAutoAddedInCart) {
            var updates = {};
            updates[freeProductAutoAddedInCart] = 0;
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: {
                updates: updates
              },
              dataType: 'json',
              success: successHandler,
              cache: false
            }).always(alwaysHandler);
          } else {
            updatingCart = false;
          }
  
        
  
        //IMPORTANT: remember to update the 'updatingCart' variable on all possible sync or async flows
  
      } else {
        updatingCart = false;
      }
    }
  }, 250);

}

function updateCartDesc(openSideCart){
  	$.ajax({
		type: 'GET',
		url: '/cart?view=side-cart',
		cache: false,
      	success: function(data){
            
          $('#loading-overlay').hide();

          var animate = true;
          if($('#side-cart').width()>0 && $('#side-cart').hasClass('open')) {
            animate = false;
          }
          if (setFreeProductWithScript()) {
            return;
          }  //Disabling the free product. SIO-358
          $('#side-cart').remove();
          $('#page').append(data);
          if(modal) modal.close();
          if(openSideCart){
            showSideCart(animate);
          }
          //Amazon DSP
          var _pix = document.getElementById('_pix_id_05938085-09ae-8da2-8251-5bcb16e1dfab');if (!_pix) { var protocol = '//'; var a = Math.random() * 1000000000000000000; _pix = document.createElement('iframe'); _pix.style.display = 'none'; _pix.setAttribute('src', protocol + 's.amazon-adsystem.com/iu3?d=generic&ex-fargs=%3Fid%3D05938085-09ae-8da2-8251-5bcb16e1dfab%26type%3DUNKNOWN%26m%3D1&ex-fch=416613&ex-src=https://www.siobeauty.com/&ex-hargs=v%3D1.0%3Bc%3D7395487400501%3Bp%3D05938085-09AE-8DA2-8251-5BCB16E1DFAB' + '&cb=' + a);_pix.setAttribute('title','Amazon DSP'); _pix.setAttribute('id','_pix_id_05938085-09ae-8da2-8251-5bcb16e1dfab'); document.body.appendChild(_pix);}

      	}
	});
}

function updateCartDescAndSelectGifts(form){
  $.ajax({
    type: 'GET',
    url: '/cart?view=mini-cart',
    cache: false,
    success: function(data){
      //$('#loading-overlay').hide();
      $('.mini-cart').remove();
      $('.top-utils li.cart-wrap:visible').append(data);
      //selectGifts(form);
      selectGifts(false);
    }
  });
}

function showMiniCart(animate) {

    $('body, html').css({overflow: 'hidden'});
    $('.header .cart-wrap a').addClass('opened');
    $('.mini-cart').show();
  
}

function hideMiniCart() {
  $('body, html').css({overflow: ''});
  $('.header .cart-wrap > a').removeClass('opened');
  $('.mini-cart').hide();  
}

function showSideCart(animate) {
  $('body, html').css({overflow: 'hidden'});
  $('#page').addClass('mode-overlay');
  if(animate) {
    setTimeout(function(){$('#side-cart').addClass('open')}, 100);
  } else {
    $('#side-cart').removeClass('ease-animation-slow');
  	$('#side-cart').addClass('open');
    setTimeout(function(){$('#side-cart').addClass('ease-animation-slow')}, 200);
  }
  Simplistic.trapFocus({
    $container: $('#side-cart'), 
    namespace: 'side-cart'
  });

  gtag('event', 'mini cart opened',{ event_category: 'mini cart' });
}

function hideSideCart() {
  $('#side-cart').removeClass('open');
  $('#page').removeClass('mode-overlay');
  $('body, html').css({overflow: ''});
  Simplistic.removeTrapFocus({
    $container: $('#side-cart'), 
    namespace: 'side-cart'
  });
  gtag('event', 'close mini cart',{ event_category: 'mini cart' });
}

window.SimplisticJS = function (){
  this.formatMoney = "$ \{\{amount\}\}";

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  this.trapFocus = function(options) {
    this.beforeTrapFocus = $(':focus');
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  this.removeTrapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }
    if(this.beforeTrapFocus) {
    	this.beforeTrapFocus.focus();
      	this.beforeTrapFocus = false;
    }

    $(document).off(eventName);
  }
  
  this.handleize = function (str) {
    //basic implementation
    //source https://gist.github.com/dlindenkreuz/a439ec4b939f0561d6d9
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  };

  this.getQueryParam = function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  this.randomstring = function(L){
    var s= '';
    var randomchar=function(){
      var n= Math.floor(Math.random()*62);
      if(n<10) return n; //1-10
      if(n<36) return String.fromCharCode(n+55); //A-Z
      return String.fromCharCode(n+61); //a-z
    }
    while(s.length< L) s+= randomchar();
    return s;
  }

  this.validateEmail = function(email) {
    //var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    var re = /^([\w-]+(?:\.?\+?[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
  }

  this.openModal = function(content, css) {
    modal = new tingle.modal({
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: "Close",
      cssClass: [css]
    });
    modal.setContent(content);
    modal.open();
  }
  
  this.openModalFreeGift = function(content, css) {
    modal = new tingle.modal({
      closeMethods: [],
      closeLabel: "Close",
      cssClass: [css]
    });
    modal.setContent(content);
    modal.open();
  }

  this.onImagesLoaded = function(images, callback){
    var imagesLoaded = 0;
    images.each(function(){
      var img = new Image();
      img.onload = function() {
        imagesLoaded++;
        if(imagesLoaded==images.length) {
          callback();
        }
      };
      img.src = $(this).attr('src');
    });
  };
};
window.Simplistic = new SimplisticJS();